import Actions from "./Actions";
import { CIDMGroup, GroupList,MembershipType } from "../../booking-table/CustomCells";
import { ACTION_CELL_STYLE, ACTION_COLUMN_FLEX } from "../../components/tableMetaHelpers";

export const GroupTableMeta = {
  fields: {
    groupName: {
      text: "Booking group",
      headProps: {
        style: {
          flex: "0 1 15%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 15%",
        },
      },
    },
    membership: {
      component: MembershipType,
      text: "Membership type",
      headProps: {
        style: {
          flex: "0 1 25%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 25%",
        },
      },  
    },
    cidm: {
      component: CIDMGroup,
      text: "CIDM Group",
      headProps: {
        style: {
          flex: "0 1 25%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 25%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 500,
          whiteSpace: "nowrap",
          paddingRight: 15,
        },
      },
    },
    usersString: {
      component: GroupList,
      text: "Users",
      headProps: {
        style: {
          flex: "0 1 25%",
        },
      },
      cellProps: {
        style: {
          flex: "0 1 25%",
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: 500,
          whiteSpace: "nowrap",
          paddingRight: 15,
        },
      },
    },
    action: {
      component: Actions,
      headProps: {
        style: {
          flex: ACTION_COLUMN_FLEX,
        },
      },
      cellProps: {
        style: {
          flex: ACTION_COLUMN_FLEX,
          ...ACTION_CELL_STYLE,
        },
      },
    },
  },
};

export default GroupTableMeta;
